import React, { useContext } from "react";
import { UserContext } from "../Context";

export default function Dashboard() {
  const user = useContext(UserContext);

  return (
    <>
      <nav className="navbar bg-body-tertiary">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Dashboard</span>
        </div>
      </nav>
      <div dir="ltr" className="p-3">
        <h2>Welcome, {user.username}!</h2>
        <p>This is the dashboard.</p>
      </div>
    </>
  );
}
